import { signal } from '@preact/signals-react';
import { Injectable, Scopes } from '@visiba/instantiation';

interface HeaderVisibility {
	showSearchReception: boolean;
	showMyVisits: boolean;
	showUserProfile: boolean;
	showSignOut: boolean;
}

// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
interface HeaderContextValue {
	visibility: HeaderVisibility;
	setVisibility: (config: Partial<HeaderVisibility>) => void;
	reset: () => void;
}

const DEFAULT_VISIBILITY: HeaderVisibility = {
	showSearchReception: true,
	showMyVisits: true,
	showUserProfile: true,
	showSignOut: true,
};

@Injectable({
	scope: Scopes.Singleton,
})
export class HeaderStateService {
	public visibility = signal<HeaderVisibility>(DEFAULT_VISIBILITY);

	public setVisibility(config: Partial<HeaderVisibility>) {
		this.visibility.value = { ...this.visibility.value, ...config };
	}

	public reset() {
		this.visibility.value = DEFAULT_VISIBILITY;
	}
}
